import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { DynamicRepositoryNameField } from '../DynamicRepositoryNameField/DynamicRepositoryNameField';

/**
 * Shared repository name field for GitHub and Bitbucket.
 * Both providers use the DPX owner-type-purpose builder.
 */
export const VcsRepositoryNameField = (
  props: FieldExtensionComponentProps<string>,
) => {
  return <DynamicRepositoryNameField {...props} />;
};
